<!--  -->
<template>
  <div class="jobList">
    <div class="select_job">
      <div
        class="select_fenlei"
        :class="{ active: index == selectShow }"
        v-for="(item, index) in select_fenlei"
        :key="index"
        @click="changeJob(index, item.cid)"
        v-html="item.fenlei"
      >
      </div>
    </div>
    <div class="job_box">
      <div class="prev" @click="arrowClick('prev')">
        <img src="../../assets/left.png" />
      </div>
      <el-carousel
        :autoplay="false"
        trigger="click"
        height="700px"
        ref="cardShow"
        arrow="never"
      >
        <el-carousel-item v-for="(item, index) in jobList" :key="index">
          <div v-html="item.msg" class="jobBox"></div>
          <div class="toudi">
            <router-link :to="{path:'/resume',query:{id:item.id}}" v-if="isshow == 1">
              <span>{{ toudi }}</span>
            </router-link>
            <span v-if="isshow == 0" v-html="toemail"></span>
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- <div
        class="msgbox"
        v-for="(item, index) in jobList"
        :key="index"
        v-html="item.msg"
      ></div> -->
      <div class="next" @click="arrowClick('next')">
        <img src="../../assets/right.png" />
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      isshow: 0, //是否显示投递按钮0否(国外),1是(中国)
      toudi: "", //投递简历
      toemail:
        "Please send your resume to us: <a href='mailto:HR@broncus.com' target='_blank'>HR@broncus.com</a>", //Please send your resume to us: HR@broncus.com
      jobList: [],
      distance: 0,
      step: 480,
      selectShow: 0,
      select_fenlei: [
        /* 
        { fenlei: "研发类" },
        { fenlei: "销售类" },
        { fenlei: "运营类" },
       */
      ],
      job_id: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    changeJob(index, cid) {
      this.selectShow = index;
      //点击切换 请求工作分类数据
      this.get_list(cid);
    },
    arrowClick(val) {
      if (val === "next") {
        this.$refs.cardShow.next();
      } else {
        this.$refs.cardShow.prev();
      }
    },
    //1.得到分类
    get_class() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 48,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.select_fenlei.push({
                cid: k.id,
                fenlei: k.title,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.得到分类下数据
    get_list(cid) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: cid,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.jobList = [];
            $.each(obj.data, function (i, k) {
              that.jobList.push({
                id:k.id,
                msg: k.msg,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          console.log(obj);
          if (!obj.region) {
            that.isshow = 1; //直接投递
          } else {
            that.isshow = 0; //发邮件提示
          }
          if (obj.code == "0000") {
            that.toudi = obj.data["tdjl"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.get_class();
    this.get_list(49);
    this.get_fanyi();

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.mover();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.jobList {
  width: 1200px;
  margin: 70px auto;
  background: #ffffff;
  // border: 1px solid #e6e6e6;
  position: relative;
  .toudi {
    text-align: center;
    height: 60px;
    a {
      padding: 18px 50px;
      background: #8553a2;
      border-radius: 5px;
      span {
        font-size: 1.2rem;
        color: $text-color;
      }
    }
  }
  .job_box {
    border: 1px solid #e6e6e6;
    padding: 0 10px;
  }
  .select_job {
    width: 100%;
    margin: 20px 0;
    display: flex;
    justify-content: flex-end;
    .select_fenlei {
      cursor: pointer;
      border: 1px solid #f8ad17;
      width: 100px;
      background-color: #fffef3;
      text-align: center;
      border-radius: 10px;
      padding: 10px 0;
      margin: 0 10px;
    }
    .active {
      background-color: #ffc85a;
      color: #fff;
    }
  }
  .prev {
    position: absolute;
    left: -60px;
    top: 60%;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .next {
    position: absolute;
    right: -60px;
    top: 60%;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .jobBox {
    width: 100%;
    height: 540px;
    overflow-y: auto;
    margin: 10px 0;
    padding: 20px 10px;
    margin-bottom: 60px;
    .msgbox {
      padding: 0 20px 30px;
      border-bottom: 1px solid #969696;
    }
    .msgbox:not(:first-child) {
      padding-top: 30px;
    }
  }
}
.jobList >>> .el-carousel__arrow--left {
  left: 0px;
}
.jobList >>> .el-carousel__arrow--right {
  right: 0px;
}
.jobBox::-webkit-scrollbar {
  width: 5px;
  height: 1px;
}
.jobBox::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #f8ad17;
}
.jobBox::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #e5e5e5;
}
@media screen and (max-width: $main-width) {
  .jobList {
    width: 90%;
    .prev {
      left: 0px;
      top: 101%;
    }
    .next {
      position: absolute;
      right: 0px;
      top: 101%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/joinUs/JobList.vue